/* * @Description: 新建/编辑广告组页面 * @Author: yanzhigen@batmobi.net * @Date:
2018-10-25 15:15:24 * @LastEditors: yanzhigen@batmobi.net * @LastEditTime:
2018-11-17 18:16:13 */
<template>
  <div class="campaign">
    <!-- 名称 -->
    <div class="panel panel-btn">
      <div
        v-if="
          status.type == 'campaign' &&
            ((status.action == 'add' && !status.id) || status.action == 'copy')
        "
        class="panel-row"
      >
        <span class="panel-row-label">
          <span>广告系列名称</span>
          <span
            v-if="campaignError.seriesId && blur.seriesId"
            class="panel-row-error"
          >
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >请选择广告系列
          </span>
        </span>
        <Select
          v-model="seriesParams.id"
          @on-change="onChangeSeries"
          placeholder="请选择广告系列"
          :filterable="true"
        >
          <Option v-for="item in seriesList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </div>
      <div v-else class="panel-row">
        <p
          class="panel-row-label showregular"
          style="display:block;"
          :title="seriesParams.name"
          :class="{ 'no-margin': 1 }"
        >
          广告系列名称：{{ seriesParams.name }}
        </p>
      </div>
    </div>
    <!-- 形式 -->
    <!-- <div v-if="status.action=='add'||status.type=='series'" class="panel panel-btn">
        <div class="panel-row">
            <p class="panel-row-label" :class="{'no-margin':1}">
                <span style="margin-right:0.2rem">新建形式：</span>
                <cRadio @click="$set(campaignParams,'batch',false)"
                        :status="!campaignParams.batch"
                        label="单个新建" />
                <cRadio @click="$set(campaignParams,'batch',true)"
                        :status="campaignParams.batch"
                        label="批量新建" />
            </p>
        </div>
        </div>-->

    <div class="panel" id="direct">
      <div class="panel-title">定向条件</div>
      <!-- 国家定向 -->
      <div v-if="!campaignParams.batch" class="panel-row">
        <p class="panel-row-label">国家定向</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetCountriesType', 0)"
            :status="campaignParams.targetCountriesType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetCountriesType', 1)"
            :status="campaignParams.targetCountriesType == 1"
            label="白名单"
          />
          <cRadio
            @click="$set(campaignParams, 'targetCountriesType', 2)"
            :status="campaignParams.targetCountriesType == 2"
            label="黑名单"
          />
        </p>
        <cDirect
          v-if="campaignParams.targetCountriesType"
          v-model="campaignParams.targetCountries"
          style="margin-top:0.1rem;"
          :list="countryList"
          :btnType="
            campaignParams.targetCountriesType == 1 ? 'info' : 'warning'
          "
          code="code"
          left="code"
          right="name"
          tagName="code"
          :searchLeftOnly="true"
          label="国家"
        />
      </div>
      <!-- 国家变量定向 -->
      <div v-else class="panel-row">
        <p class="panel-row-label">国家定向</p>
        <template v-for="(item, index) in variable.country">
          <p :key="'a' + index" class="panel-row-radio-group">
            <cRadio
              @click="$set(item, 'targetCountriesType', 0)"
              :status="item.targetCountriesType == 0"
              label="不限"
            />
            <cRadio
              @click="$set(item, 'targetCountriesType', 1)"
              :status="item.targetCountriesType == 1"
              label="白名单"
            />
            <cRadio
              @click="$set(item, 'targetCountriesType', 2)"
              :status="item.targetCountriesType == 2"
              label="黑名单"
            />
            <span
              v-if="variable.country.length > 1 || index"
              @click="variable.country.splice(index, 1)"
              class="icon-minus"
              title="删除"
            >
              <Icon type="minus-circled"></Icon>
            </span>
          </p>
          <cDirect
            v-if="item.targetCountriesType"
            :key="'b' + index"
            v-model="item.targetCountries"
            style="margin-bottom:0.1rem;"
            :list="countryList"
            :btnType="item.targetCountriesType == 1 ? 'info' : 'warning'"
            code="code"
            left="code"
            right="name"
            tagName="code"
            :searchLeftOnly="true"
            label="国家"
          />
        </template>
        <!-- 添加变量 -->
        <!-- <div class="panel-row">
                <div class="panel-row-radio-group">
                    <div @click="variable.country.push({targetCountriesType:0,targetCountries:''})" class="add-text" style="width:2.6rem"><p>+ 添加国家定向变量</p></div>
                    <div v-if="variable.country.length==1" @click="autoAdd('country')" class="add-text" style="width:1.2rem;margin-left:0.2rem"><p>自动添加</p></div>
                </div>
                </div>-->
      </div>
      <!-- 语言定向 -->
      <div v-if="!campaignParams.batch" class="panel-row">
        <p class="panel-row-label">
          <span>语言定向</span>
          <i
            v-if="status.action == 'add'"
            @click="translate(campaignParams.translate)"
            class="icon icon-checkbox"
            style="margin-left:0.3rem"
            :class="{ active: campaignParams.translate }"
          ></i>
          <span v-if="status.action == 'add'" style="margin-left:0.1rem"
            >自动将广告文案翻译为当前定向的语言</span
          >
        </p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetLanguagesType', 0)"
            :status="campaignParams.targetLanguagesType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetLanguagesType', 1)"
            :status="campaignParams.targetLanguagesType == 1"
            label="白名单"
          />
          <cRadio
            @click="$set(campaignParams, 'targetLanguagesType', 2)"
            :status="campaignParams.targetLanguagesType == 2"
            label="黑名单"
          />
        </p>
        <cDirect
          v-if="campaignParams.targetLanguagesType"
          v-model="campaignParams.targetLanguages"
          :list="languageList"
          :btnType="
            campaignParams.targetLanguagesType == 1 ? 'info' : 'warning'
          "
          code="code"
          left="code"
          right="name"
          tagName="code"
          :searchLeftOnly="true"
          label="语言"
        />
      </div>
      <!-- 语言变量定向 -->
      <div v-else class="panel-row">
        <p class="panel-row-label">
          <span>语言定向</span>
          <i
            @click="translate(campaignParams.translate)"
            class="icon icon-checkbox"
            style="margin-left:0.3rem"
            :class="{ active: campaignParams.translate }"
          ></i>
          <span style="margin-left:0.1rem"
            >自动将广告文案翻译为当前定向的语言</span
          >
        </p>
        <template v-if="!campaignParams.translate">
          <template v-for="(item, index) in variable.language">
            <p :key="'a' + index" class="panel-row-radio-group">
              <cRadio
                @click="$set(item, 'targetLanguagesType', 0)"
                :status="item.targetLanguagesType == 0"
                label="不限"
              />
              <cRadio
                @click="$set(item, 'targetLanguagesType', 1)"
                :status="item.targetLanguagesType == 1"
                label="白名单"
              />
              <cRadio
                @click="$set(item, 'targetLanguagesType', 2)"
                :status="item.targetLanguagesType == 2"
                label="黑名单"
              />
              <span
                v-if="variable.language.length > 1 || index"
                @click="variable.language.splice(index, 1)"
                class="icon-minus"
                title="删除"
              >
                <Icon type="minus-circled"></Icon>
              </span>
            </p>
            <cDirect
              v-if="item.targetLanguagesType"
              :key="'b' + index"
              v-model="item.targetLanguages"
              style="margin-bottom:0.1rem;"
              :list="languageList"
              :btnType="item.targetLanguagesType == 1 ? 'info' : 'warning'"
              code="code"
              left="code"
              right="name"
              tagName="code"
              :searchLeftOnly="true"
              label="语言"
            />
          </template>
        </template>
        <!-- 自动翻译 -->
        <div class="c-direct" v-else>
          <div class="direct-header">
            <div class="direct-language-group">
              <Button
                v-for="(item, index) in variable.language"
                :key="index"
                size="small"
                type="info"
                class="selected-item"
              >
                <span>{{ item.targetLanguages }}</span>
                <span @click="variable.language.splice(index, 1)">
                  <Icon type="close-round"></Icon>
                </span>
              </Button>
              <!-- <span class="no-data" v-if="!selectedArr.length">No Data</span> -->
            </div>
            <div class="direct-tip">
              <span>
                将拆分为
                <i style="color:#169bd5">{{ variable.language.length }}</i
                >个不同语言的广告组，其下广告文案自动翻译为对应语言
              </span>
            </div>
          </div>
        </div>
        <!-- 添加变量 -->
        <div v-if="!campaignParams.translate" class="panel-row">
          <div class="panel-row-radio-group">
            <div
              @click="
                variable.language.push({
                  targetLanguagesType: 0,
                  targetLanguages: '',
                })
              "
              class="add-text"
              style="width:2.6rem"
            >
              <p>+ 添加语言定向变量</p>
            </div>
            <div
              v-if="variable.language.length == 1"
              @click="autoAdd('language')"
              class="add-text"
              style="width:1.2rem;margin-left:0.2rem"
            >
              <p>自动添加</p>
            </div>
          </div>
        </div>
      </div>
      <!-- IP定向 -->
      <div class="panel-row">
        <p class="panel-row-label">
          <span>IP定向</span>
          <span v-if="campaignError.targetIps" class="panel-row-error">
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >请输入两条正确的IP起止地址
          </span>
        </p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetIpsType', 0)"
            :status="campaignParams.targetIpsType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetIpsType', 1)"
            :status="campaignParams.targetIpsType == 1"
            label="限定"
          />
        </p>
        <div v-if="campaignParams.targetIpsType == 1" class="ip-box">
          <div class="ip" v-for="(item, index) in ipList" :key="index">
            <input
              class="ip-text"
              v-model="item.start"
              placeholder="请输入IP地址"
            />
            <span class="ip-to">TO</span>
            <input
              class="ip-text"
              v-model="item.end"
              placeholder="请输入IP地址"
            />
          </div>
        </div>
      </div>
      <!-- 操作系统 -->
      <div class="panel-row">
        <p class="panel-row-label">
          操作系统{{
            seriesParams.autoCampaignType == 1
              ? `：${platformList[campaignParams.targetOsType].label}`
              : ""
          }}
        </p>
        <template v-show="seriesParams.autoCampaignType != 1">
          <p class="panel-row-radio-group">
            <cRadio
              v-for="item in platformList"
              :key="item.value"
              @click="onChangeOs(item.value)"
              :status="campaignParams.targetOsType == item.value"
              :label="item.label"
            />
          </p>
          <div
            v-show="campaignParams.targetOsType != 0"
            style="margin-top:0.1rem"
          >
            <cDropdown
              v-model="campaignParams.targetOs"
              :sourceList="currentOsList"
              code="version"
              label="name"
              style="width:3.2rem;"
            >
              <Input
                :value="targetOsLabel"
                readonly
                style="width:3.2rem;"
                icon="arrow-down-b"
              />
            </cDropdown>
          </div>
        </template>
      </div>
      <!-- 设备类型 -->
      <div class="panel-row">
        <p class="panel-row-label">设备类型</p>
        <p class="panel-row-radio-group">
          <cRadio
            v-for="item in deviceTypeList"
            :key="item.value"
            @click="$set(campaignParams, 'deviceType', item.value)"
            :status="campaignParams.deviceType == item.value"
            :label="item.label"
          />
        </p>
      </div>
      <!-- 网络类型 -->
      <div class="panel-row">
        <p class="panel-row-label">网络类型</p>
        <p class="panel-row-radio-group">
          <cRadio
            v-for="item in connectionTypeList"
            :key="item.value"
            @click="$set(campaignParams, 'connectionType', item.value)"
            :status="campaignParams.connectionType == item.value"
            :label="item.label"
          />
        </p>
      </div>
    </div>
    <div class="panel" id="media">
      <div class="panel-title">媒体选择</div>
      <!-- 渠道选择 -->
      <div class="panel-row">
        <h3 class="panel-row-label">
          <span>渠道选择</span>
          <span
            v-if="campaignError.targetSourceChannelIds"
            class="panel-row-error"
          >
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >请选择渠道
          </span>
        </h3>
        <div>
          <span
            v-for="item in sourceList"
            class="btn-channel"
            :class="{
              selected: campaignParams.targetSourceChannelIds.some(
                (source) => source.sourceId == item.id
              ),
            }"
            :key="item.id"
            @click="onClickChannel(item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <!-- 广告位选择 -->
      <div
        v-if="campaignParams.targetSourceChannelIds.length && 0"
        class="panel-row"
      >
        <p class="panel-row-label">广告位选择</p>
        <template v-for="source in campaignParams.targetSourceChannelIds">
          <p
            :key="source.id"
            class="panel-row-radio-group"
            style="margin-bottom:0.1rem;"
          >
            <span class="btn-channel selected">{{ source.name }}</span>
            <cRadio
              @click="$set(source, 'type', 0)"
              :status="source.type == 0"
              style="margin-left:0.1rem;"
              label="不限"
            />
            <cRadio
              @click="$set(source, 'type', 1)"
              :status="source.type == 1"
              label="白名单"
            />
            <cRadio
              @click="$set(source, 'type', 2)"
              :status="source.type == 2"
              label="黑名单"
            />
          </p>
          <c-direct
            v-if="source.type"
            :key="source.id"
            v-model="source.ids"
            :list="source.adsenses"
            :btnType="source.type == 1 ? 'info' : 'warning'"
            code="id"
            tagName="id"
            type="1"
            style="margin-bottom:0.2rem;"
            label="广告位"
          />
        </template>
      </div>
      <!-- 媒体分类 -->
      <div class="panel-row">
        <p class="panel-row-label">媒体分类定向</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetCategoryType', 0)"
            :status="campaignParams.targetCategoryType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetCategoryType', 1)"
            :status="campaignParams.targetCategoryType == 1"
            label="白名单"
          />
          <cRadio
            @click="$set(campaignParams, 'targetCategoryType', 2)"
            :status="campaignParams.targetCategoryType == 2"
            label="黑名单"
          />
        </p>
        <c-direct
          v-if="campaignParams.targetCategoryType"
          v-model="campaignParams.targetCategory"
          :list="categoryList"
          :btnType="campaignParams.targetCategoryType == 1 ? 'info' : 'warning'"
          code="categoryCode"
          left="categoryCode"
          right="bidReqLastday"
          tagName="categoryCode"
          :searchLeftOnly="true"
          label="媒体分类"
        />
      </div>
      <!-- 媒体定向 -->
      <div class="panel-row">
        <p class="panel-row-label">媒体定向</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetBundleType', 0)"
            :status="campaignParams.targetBundleType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetBundleType', 1)"
            :status="campaignParams.targetBundleType == 1"
            label="白名单"
          />
          <cRadio
            @click="$set(campaignParams, 'targetBundleType', 2)"
            :status="campaignParams.targetBundleType == 2"
            label="黑名单"
          />
        </p>
        <c-direct
          v-if="campaignParams.targetBundleType"
          v-model="campaignParams.targetBundles"
          :list="bundleList"
          :btnType="campaignParams.targetBundleType == 1 ? 'info' : 'warning'"
          code="name"
          left="name"
          tagName="name"
          :searchLeftOnly="true"
          label="媒体"
        />
      </div>

      <!-- 子渠道定向 -->
      <div class="panel-row">
        <p class="panel-row-label">子渠道定向</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetChannelType', 0)"
            :status="campaignParams.targetChannelType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetChannelType', 1)"
            :status="campaignParams.targetChannelType == 1"
            label="白名单"
          />
          <cRadio
            @click="$set(campaignParams, 'targetChannelType', 2)"
            :status="campaignParams.targetChannelType == 2"
            label="黑名单"
          />
        </p>
        <el-input
          v-if="campaignParams.targetChannelType"
          type="text"
          size="small"
          style="padding-top:15px"
          placeholder="多个信息用英文逗号分割"
          v-model="campaignParams.targetChannels"
          onafterpaste="this.value=this.value.replace(/，/g,',')"
          onkeyup="this.value=this.value.replace(/，/g,',')"
        >
        </el-input>
      </div>
    </div>
    <div class="panel" id="budget">
      <div class="panel-title">预算排期</div>
      <!-- 广告组名称 -->
      <div v-if="!campaignParams.batch" class="panel-row">
        <p class="panel-row-label">
          <span>广告组名称</span>
          <span v-if="campaignError.name && blur.name" class="panel-row-error">
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >请输入100字以内的广告组名称
          </span>
        </p>
        <Input
          @on-blur="blur.name = true"
          v-model="campaignParams.name"
          placeholder="必填，限制字数100个字"
          :maxlength="100"
        />
      </div>
      <!-- 时段 -->
      <div class="panel-row">
        <p class="panel-row-label">时段</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'targetTimeType', 0)"
            :status="campaignParams.targetTimeType == 0"
            label="不限"
          />
          <cRadio
            @click="$set(campaignParams, 'targetTimeType', 1)"
            :status="campaignParams.targetTimeType == 1"
            label="限定"
          />
        </p>
        <Drag
          v-show="campaignParams.targetTimeType"
          @timezone="(str) => $set(campaignParams, 'targetTime', str)"
          :timezone="campaignParams.targetTime"
        />
      </div>
      <!-- 日预算 -->
      <div class="panel-row">
        <p class="panel-row-label">
          <span>日预算</span>
          <span v-if="campaignError.dailyBudget" class="panel-row-error">
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >日预算不能为0，并且消耗不限时，不允许选择匀速
          </span>
        </p>
        <div
          v-if="
            userInfo.autoType == 1 &&
              campaignParams.dailyBudgetType == 'dailyImp' &&
              0
          "
          class="dailyImp-box"
        >
          <Select
            v-model="campaignParams.dailyBudgetType"
            slot="prepend"
            style="line-height: 36px;width:80px;"
          >
            <Option value="dailyBudget">花费</Option>
            <Option value="dailyImp">展示</Option>
            <Option value="dailyClick">点击</Option>
          </Select>
          <span class="dailyImp-label">CPM *</span>
          <input
            class="dailyImp-input"
            v-model.trim="campaignParams.dailyImpCpmTimes"
            @keyup="mixinRegNum($event, 0, 1, 1000000)"
            @change="mixinRegNum($event, 0, 1, 1000000)"
            :maxlength="7"
          />
          <span class="dailyImp-label">+</span>
          <input
            v-model.trim="campaignParams.dailyBudgetValue"
            @keyup="mixinRegNum($event, 0, 1, 1000)"
            @change="mixinRegNum($event, 0, 1, 1000)"
            :maxlength="4"
            class="dailyImp-input"
          />
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyBudget'"
            class="dailyImp-label"
            >美元</span
          >
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyImp'"
            class="dailyImp-label"
            >千次</span
          >
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyClick'"
            class="dailyImp-label"
            >次</span
          >
        </div>
        <Input
          v-else
          v-model.trim="campaignParams.dailyBudgetValue"
          @on-keyup="(e) => mixinRegNum(e, 0)"
          @on-change="(e) => mixinRegNum(e, 0)"
          :maxlength="8"
          placeholder="选填，默认不限"
        >
          <Select
            v-model="campaignParams.dailyBudgetType"
            slot="prepend"
            style="line-height: 36px;width:80px;"
          >
            <Option value="dailyBudget">花费</Option>
            <Option value="dailyImp">展示</Option>
            <Option value="dailyClick">点击</Option>
          </Select>
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyBudget'"
            slot="append"
            >美元</span
          >
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyImp'"
            slot="append"
            >千次</span
          >
          <span
            v-if="campaignParams.dailyBudgetType == 'dailyClick'"
            slot="append"
            >次</span
          >
        </Input>
      </div>
      <!-- 速度 -->
      <div class="panel-row">
        <p class="panel-row-label">速度</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'speed', 2)"
            :status="campaignParams.speed == 2"
            label="匀速"
          />
          <cRadio
            @click="$set(campaignParams, 'speed', 1)"
            :status="campaignParams.speed == 1"
            label="快速"
          />
        </p>
      </div>
      <!-- 出价 -->
      <div class="panel-row">
        <p class="panel-row-label">
          <!-- <span>结算出价</span> -->
          <span>优化目标</span>
          <span
            v-if="campaignError.bidPrice && blur.bidPrice"
            class="panel-row-error"
          >
            <Icon class="panel-row-error-icon" type="close-circled"></Icon>
            <!-- <span v-if="userInfo.source=='batmobi'">出价不得少于0</span>
                        <span
                            v-else
                        >{{bidTypeList[campaignParams.bidType].label}}出价不得小于${{bidTypeList[campaignParams.bidType].min}}</span> -->
            <span>优化目标不能为空</span>
          </span>
        </p>
        <Input
          v-model.trim="campaignParams.bidPrice"
          @on-keyup="
            (e) =>
              (campaignParams.bidPrice = mixinRegNum(e, 5, 0, 99999999.99999))
          "
          @on-change="
            (e) =>
              (campaignParams.bidPrice = mixinRegNum(e, 5, 0, 99999999.99999))
          "
          :maxlength="14"
          @on-blur="blur.bidPrice = true"
          icon="social-usd"
          :placeholder="
            `必填，请输入不少于$${
              userInfo.source == 'batmobi'
                ? 0
                : bidTypeList[campaignParams.bidType].min
            }的出价`
          "
        >
          <Select
            v-model="campaignParams.eventType"
            slot="prepend"
            style="line-height: 36px;width:80px;"
          >
            <!-- <Option :value="2">CPA</Option>
                        <Option :value="3">CPC</Option>
                        <Option :value="1">CPM</Option> -->
            <Option
              :value="item.value"
              v-for="item in campaignOptimizationOptions"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </Input>
      </div>

      <!-- 广告系列状态 -->
      <div class="panel-row">
        <p class="panel-row-label">广告组状态</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(campaignParams, 'status', 1)"
            :status="campaignParams.status == 1"
            label="ON"
          />
          <cRadio
            @click="$set(campaignParams, 'status', 0)"
            :status="campaignParams.status == 0"
            label="OFF"
          />
        </p>
      </div>
    </div>

    <div class="panel" id="operate">
      <div class="panel-title">运营管理</div>

      <div class="panel-row">
        <p class="panel-row-label">投放出价</p>
        <el-input
          size="small"
          v-model="campaignParams.pbidPrice"
          :placeholder="
            `必填，请输入不少于$${
              userInfo.source == 'batmobi'
                ? 0
                : bidTypeList[campaignParams.bidType].min
            }的出价`
          "
        ></el-input>
      </div>

      <div class="panel-row">
        <div class="panel-row-maxDiv">
          <div
            class="div"
            v-if="campaignParams.bidType != 1"
            style="margin-right: 70px"
          >
            <p class="panel-row-label">pctr</p>
            <el-input
              size="small"
              style="width:240px;"
              oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              v-model="campaignParams.pctr"
              placeholder="0~1（最多两位小数）"
            ></el-input>
          </div>
          <div class="div" v-if="campaignParams.bidType == 2">
            <p class="panel-row-label">pcvr</p>
            <el-input
              size="small"
              style="width:240px;"
              oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              v-model="campaignParams.pcvr"
              placeholder="0~1（最多两位小数）"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="panel-row">
        <p class="panel-row-label">影响时间范围（东八区）</p>
        <div>
          <el-date-picker
            style="width: 100%;"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="campaignParams.pbidPriceTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="影响开始日期"
            end-placeholder="影响结束日期"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="panel-row">
        <div class="panel-row-maxDiv">
          <div class="div" style="margin-right: 70px">
            <p class="panel-row-label">补/扣曝光占比</p>
            <!-- <span>补/扣曝光占比：</span> -->
            <el-input
              size="small"
              style="width:240px;"
              oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              v-model="campaignParams.exposureRate"
              placeholder="0~2（最多两位小数）"
            ></el-input>
          </div>
          <div class="div">
            <p class="panel-row-label">补/扣点击占比</p>
            <el-input
              size="small"
              style="width:240px;"
              oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              v-model="campaignParams.clickRate"
              placeholder="0~2（最多两位小数）"
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 自动优化设置 -->
    <div class="panel panel-btn" id="optimization">
      <div
        @click="show.autoOptimization = !show.autoOptimization"
        class="panel-row optimization-title"
        style="margin-bottom:0"
      >
        <span class="btn-blue">自动优化规则</span>
        <i
          :class="
            show.autoOptimization ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
          "
        />
      </div>
      <autoOptimization
        v-show="show.autoOptimization"
        style="margin-top:0.24rem"
      />
    </div>
    <!-- 保存 -->
    <div class="panel panel-btn">
      <Button
        v-if="status.type != 'campaign'"
        type="default"
        size="large"
        @click="$emit('last-step')"
        style="margin-right:0.3rem;"
        >上一步</Button
      >
      <Button
        v-if="!campaignParams.batch"
        type="primary"
        size="large"
        @click="onNextStep"
        style="margin-right:0.3rem;"
        >新建广告</Button
      >
      <Button
        v-else
        type="primary"
        size="large"
        @click="onClickPreview"
        style="margin-right:0.3rem;"
        >广告组预览</Button
      >
      <Button
        v-if="!campaignParams.batch"
        type="primary"
        size="large"
        @click="onSave(false)"
        >保存并关闭</Button
      >
      <Button
        v-if="status.type == 'campaign' && status.action == 'copy'"
        type="primary"
        size="large"
        @click="onSave(true)"
        style="margin-left:0.3rem;"
        >复制原广告组广告</Button
      >
    </div>
  </div>
</template>
<script>
import cRadio from "@/components/commons/cRadio";
import cDirect from "@/components/commons/cDirect";
import cDropdown from "@/components/commons/cDropdown";
import Drag from "@/components/commons/Drag";
import autoOptimization from "@/components/NewPromotion/autoOptimization";
import mixins from "@/mixins";
export default {
  name: "Campaign",
  mixins: [mixins],
  components: { cRadio, cDirect, Drag, cDropdown, autoOptimization },
  data() {
    return {
      blur: {
        name: false,
        bidPrice: false,
        seriesId: false,
      },
      show: {
        autoOptimization: false,
      },
      //批量变量
      variable: {
        country: [{ targetCountriesType: 0, targetCountries: "" }],
        language: [{ targetLanguagesType: 0, targetLanguages: "" }],
      },
      //操作系统列表
      platformList: [
        { label: "不限", value: 0 },
        { label: "IOS", value: 1 },
        { label: "安卓", value: 2 },
      ],
      //设备类型列表
      deviceTypeList: [
        { label: "不限", value: 0 },
        { label: "Phone", value: 1 },
        { label: "Pad", value: 2 },
      ],
      //网络类型列表
      connectionTypeList: [
        { label: "不限", value: 0 },
        { label: "WIFI", value: 1 },
        { label: "2G/3G/4G", value: 2 },
      ],
      //维度
      dimensionList: { 1: "推广", 2: "创意", 3: "国家", 4: "广告位" },
      //事件范围
      timeList: { week: "周", day: "天", hour: "小时" },
      //条件
      quotaList: [
        { label: "CTR", value: 1 },
        { label: "CVR", value: 2 },
        { label: "展示量", value: 3 },
        { label: "eCPM", value: 4 },
      ],
      //大于小于
      mathList: { 1: ">", 2: "<" },
      //单位列表
      unitList: { 1: "%", 2: "%", 3: "千次", 4: "$" },
      bidTypeList: {
        1: { label: "CPM", min: "0.01" },
        2: { label: "CPA", min: "0.03" },
        3: { label: "CPC", min: "0.0006" },
      },
      urlQuery: this.mixinGetQueryObject(),
    };
  },
  computed: {
    status() {
      return this.$store.state.newPromotion.status;
    },
    userInfo() {
      return this.$store.state.newPromotion.userInfo;
    },
    seriesParams() {
      return this.$store.state.newPromotion.seriesParams;
    },
    campaignParams() {
      return this.$store.state.newPromotion.campaignParams;
    },
    campaignBatchList() {
      return this.$store.state.newPromotion.campaignBatchList;
    },
    campaignError() {
      return this.$store.getters.campaignError;
    },
    seriesList() {
      return this.$store.state.newPromotion.seriesList;
    },
    countryList() {
      return this.$store.state.newPromotion.countryList;
    },
    languageList() {
      return this.$store.state.newPromotion.languageList;
    },
    osList() {
      return this.$store.state.newPromotion.osList;
    },
    //IP列表
    ipList() {
      return this.$store.state.newPromotion.ipList;
    },
    //当前os label
    targetOsLabel() {
      const targetOsType = this.campaignParams.targetOsType;
      const targetOs = this.campaignParams.targetOs;
      if (targetOsType == 0 || targetOs == "") return "全部";
      return targetOs
        .split(",")
        .filter((item, index) => index < 4)
        .map((item, index) => {
          if (index < 3)
            return item == 0
              ? "其他"
              : `${this.platformList[targetOsType].label} ${item}`;
          if (index == 3) return "...";
        })
        .join("，");
    },
    //系统列表
    currentOsList() {
      if (this.campaignParams.targetOsType == 1) return this.osList["ios"];
      if (this.campaignParams.targetOsType == 2) return this.osList["android"];
      return [];
    },
    //渠道列表
    sourceList() {
      return this.$store.state.newPromotion.sourceList;
    },
    //媒体分类列表
    categoryList() {
      return this.$store.state.newPromotion.categoryList;
    },
    //媒体列表
    bundleList() {
      return this.$store.state.newPromotion.bundleList;
    },
    // 广告组优化目标选项
    campaignOptimizationOptions() {
      return this.$store.state.newPromotion.campaignOptimizationOptions;
    },
  },
  watch: {
    "campaignParams.targetChannelType": {
      handler(oldval, newval) {
        if (oldval == 0) this.campaignParams.targetChannels = "";
      },
    },
    "seriesParams.promotionType": function(val) {
      const optionsMap = {
        // 网站推广
        1: [
          {
            label: "注册",
            value: 2,
          },
          {
            label: "付费",
            value: 3,
          },
        ],
        // 应用推广
        2: [
          {
            label: "激活",
            value: 1,
          },
        ],
      };
      this.$store.commit("setEventType", val === 1 ? 2 : 1);
      this.$store.commit("setCampaignOptimizationOptions", optionsMap[val]);
    },
  },
  created() {
    if (this.status.action != "add")
      for (const key in this.blur) this.blur[key] = true;
  },
  methods: {
    /**
     * @desc 选择系列时获取详细信息
     */
    async onChangeSeries(id) {
      const res = await this.$axios.get(this.$port.series.getDetail, {
        params: { id, type: 1 },
      });
      const series = res.data.campaignSeries || {};
      this.$store.commit("seriesParams", {
        ...this.seriesParams,
        ...series,
      });
    },
    /**
     * @desc 选择渠道
     * @param {Source} source 渠道对象
     */
    onClickChannel(source) {
      const sources = this.campaignParams.targetSourceChannelIds,
        oldLength = sources.length,
        arr = sources.filter((item) => item.sourceId != source.id);
      if (arr.length == oldLength)
        arr.push({
          sourceId: source.id,
          type: 0,
          ids: "",
          name: source.name,
          adsenses: source.adsenses,
        });
      this.$set(this.campaignParams, "targetSourceChannelIds", arr);
    },
    /**
     * @desc 移除规则
     * @param index:number 要移除的规则索引
     */
    removeRule(index) {
      const arr = [...this.ruleArr];
      arr.splice(index, 1);
      this.ruleIds = arr.join(",");
    },
    /**
     * @desc 点击保存
     * @param {Boolean} copyOffers 复制广告组下面的广告
     */
    onSave(copyOffers) {
      console.log("this.campaignParams", this.campaignParams);
      // userInfo.source=='batmobi'?0:bidTypeList[campaignParams.bidType].min
      // return
      for (const key in this.blur) this.blur[key] = true;
      this.status.copyOffers = copyOffers;
      if (this.campaignParams.targetTimeType === 0) {
        this.$set(this.campaignParams, "targetTime", "");
      } else {
        if (!this.campaignParams.targetTime) {
          return this.$Message.error({ content: "时段不能为空", duration: 2 });
        }
      }

      // `必填，请输入不少于$${userInfo.source=='batmobi'?0:bidTypeList[campaignParams.bidType].min}的出价`
      if (
        (!this.campaignParams.pbidPrice &&
          this.campaignParams.pbidPrice != 0) ||
        this.campaignParams.pbidPrice === ""
      ) {
        return this.$Message.error({
          content: "投放出价不能为空",
          duration: 2,
        });
      } else {
        if (
          this.campaignParams.pbidPrice <
          (this.userInfo.source == "batmobi"
            ? 0
            : this.bidTypeList[this.campaignParams.bidType].min)
        ) {
          return this.$Message.error({
            content: `请输入不少于$${
              this.userInfo.source == "batmobi"
                ? 0
                : this.bidTypeList[this.campaignParams.bidType].min
            }的出价`,
            duration: 2,
          });
        }
      }
      if (this.campaignParams.bidType != "1") {
        if (
          (!this.campaignParams.pctr && this.campaignParams.pctr != 0) ||
          this.campaignParams.pctr === ""
        ) {
          return this.$Message.error({ content: "pctr不能为空", duration: 2 });
        } else {
          if (this.campaignParams.pctr && this.campaignParams.pctr > 1) {
            return this.$Message.error({
              content: "pctr不能大于1",
              duration: 2,
            });
          }
        }

        if (this.campaignParams.bidType == "2") {
          if (
            (!this.campaignParams.pcvr && this.campaignParams.pcvr != 0) ||
            this.campaignParams.pcvr === ""
          ) {
            return this.$Message.error({
              content: "pcvr不能为空",
              duration: 2,
            });
          } else {
            if (this.campaignParams.pcvr && this.campaignParams.pcvr > 1) {
              return this.$Message.error({
                content: "pcvr不能大于1",
                duration: 2,
              });
            }
          }
        }
      }

      if (
        (!this.campaignParams.exposureRate &&
          this.campaignParams.exposureRate != 0) ||
        this.campaignParams.exposureRate === ""
      ) {
        return this.$Message.error({
          content: "补/扣曝光占比不能为空",
          duration: 2,
        });
      }
      if (
        (!this.campaignParams.clickRate &&
          this.campaignParams.clickRate != 0) ||
        this.campaignParams.clickRate === ""
      ) {
        return this.$Message.error({
          content: "补/扣点击占比不能为空",
          duration: 2,
        });
      }

      if (
        this.campaignParams.exposureRate &&
        this.campaignParams.exposureRate > 2
      ) {
        return this.$Message.error({
          content: "补/扣曝光占比不能大于2",
          duration: 2,
        });
      }
      if (this.campaignParams.clickRate && this.campaignParams.clickRate > 2) {
        return this.$Message.error({
          content: "补/扣点击占比不能大于2",
          duration: 2,
        });
      }

      if (this.campaignParams.pbidPriceTime) {
        this.campaignParams.startTime = this.campaignParams.pbidPriceTime[0];
        this.campaignParams.endTime = this.campaignParams.pbidPriceTime[1];
      } else {
        this.campaignParams.startTime = "";
        this.campaignParams.endTime = "";
      }

      console.log(9999);
      console.log(this.campaignParams);
      this.$emit("submit");
    },
    /**
     * @desc 点击nextStep
     */
    onNextStep() {
      for (const key in this.blur) this.blur[key] = true;
      this.$emit("next-step", 2);
    },
    /**
     * @desc 点击广告组预览
     */
    onClickPreview() {
      for (const key in this.blur) this.blur[key] = true;
      const arr = [];
      let count = 0;
      this.variable.country.forEach((country) =>
        this.variable.language.forEach((language) => {
          count++;
          const countryName =
            !country.targetCountries || !country.targetCountriesType
              ? "国家不限"
              : country.targetCountries;
          const languageName =
            !language.targetLanguages || !language.targetLanguagesType
              ? "语言不限"
              : language.targetLanguages;
          let name = `${countryName}_${languageName
            .split(",")
            .join("&")}_0${count}`;
          if (this.campaignParams.translate) name = "AT_" + name;
          arr.push({
            ...this.campaignParams,
            targetCountriesType: country.targetCountriesType,
            targetCountries: country.targetCountriesType
              ? country.targetCountries
              : "",
            targetLanguagesType: language.targetLanguagesType,
            targetLanguages: language.targetLanguages,
            name: name,
          });
        })
      );
      this.$store.commit("campaignBatchList", arr);
      this.$emit("next-step", 1);
    },
    /**
     * @desc 改变操作系统
     * @param {String} val 选中值
     */
    onChangeOs(val) {
      if (val == this.campaignParams.targetOsType) return;
      this.campaignParams.targetOs = "";
      this.$set(this.campaignParams, "targetOsType", val);
    },
    /**
     * @desc 自动添加变量
     * @param {String} type 变量类型
     */
    autoAdd(type) {
      if (type == "country") {
        this.variable.country = this.countryList
          .filter((item, index) => index < 10)
          .map((item) => ({
            targetCountriesType: 1,
            targetCountries: item.code,
          }));
      }
      if (type == "language") {
        this.variable.language = this.languageList
          .filter((item, index) => index < 10)
          .map((item) => ({
            targetLanguagesType: 1,
            targetLanguages: item.code,
          }));
      }
    },
    /**
     * @desc 自动添加变量
     * @param {String} flag 变量类型
     */
    translate(flag) {
      const { campaignParams, variable, languageList } = this;
      if (flag) {
        variable.language = [{ targetLanguagesType: 0, targetLanguages: "" }];
        campaignParams.targetCountriesType =
          variable.country[0].targetCountriesType;
        campaignParams.targetCountries = variable.country[0].targetCountries;
      } else {
        variable.country = [
          {
            targetCountriesType: campaignParams.targetCountriesType,
            targetCountries: campaignParams.targetCountries,
          },
        ];
        variable.language = languageList
          .filter((item) => item.code != "unknown")
          .map((item) => ({
            targetLanguagesType: 1,
            targetLanguages: item.code,
          }));
      }
      campaignParams.translate = !flag;
      campaignParams.batch = !flag;
    },
  },
};
</script>
<style lang="scss">
$border: 1px solid #e9e9e9;
.dailyImp-box {
  display: flex;
  align-items: center;
  text-align: center;
  line-height: 36px;
  border-right: 1px solid #dddee1;
  & > * {
    flex: 0 0 auto;
    box-sizing: border-box;
  }
  .dailyImp-input {
    flex: 1 1 auto;
    border-top: 1px solid #dddee1;
    border-bottom: 1px solid #dddee1;
  }
  .dailyImp-label {
    padding: 0 0.2rem;
    border-top: 1px solid #dddee1;
    border-bottom: 1px solid #dddee1;
  }
}
.no-margin {
  margin: 0 !important;
}
.c-direct {
  margin-top: 0.1rem;
  width: 3.8rem;
  border-bottom: $border;
  .ivu-btn-small {
    padding: 0;
    font-size: 0.12rem;
    width: 0.44rem;
    height: 0.22rem;
  }
  .direct {
    &-header {
      min-height: 0.8rem;
      box-sizing: border-box;
      border: $border;
      border-bottom: none;
    }
  }
  .direct-language-group {
    display: flex;
    flex-wrap: wrap;
    padding: 0.1rem 0.1rem 0 0.1rem;
    .selected-item {
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;
      width: auto;
      padding: 0 0.05rem;
    }
  }
  .direct-tip {
    display: flex;
    align-items: center;
    margin: 0 0.1rem;
    line-height: 0.2rem;
    padding: 0.1rem 0;
    font-size: 0.14rem;
    border-top: $border;
  }
  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: -0.1rem;
  }
}
.campaign {
  .icon-minus {
    cursor: pointer;
    color: red;
    font-size: 0.2rem;
  }
  //渠道按钮
  .btn-channel {
    display: inline-flex;
    justify-content: center;
    margin-right: 0.18rem;
    width: 0.9rem;
    line-height: 0.32rem;
    border-radius: 0.04rem;
    border: 1px solid #dfe2e5;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.2s ease;
    &.selected {
      background: #23c52f;
      border: 1px solid #23c52f;
      color: #fff;
    }
  }
  //优化规则title
  .optimization-title {
    cursor: pointer;
    font-size: 0.2rem;
    font-weight: bold;
    & i {
      margin-left: 0.1rem;
      color: #c9c9c9;
    }
  }
  .ip-box {
    margin-top: 0.1rem;
    padding: 0.1rem;
    position: relative;
    border: 1px solid #dfe2e5;
    border-color: #23c52f;
    box-sizing: border-box;
    border-radius: 0.04rem;
    transition: all 0.5s ease;
    .ip {
      display: flex;
      align-items: center;
      line-height: 0.5rem;
      min-height: 0.5rem;
      font-size: 0.14rem;
      white-space: nowrap;
      &-text {
        flex: 1 1 auto;
        background: none;
        height: 0.35rem;
        line-height: 0.35rem;
        text-align: center;
        border-bottom: 1px solid #dfe2e5;
      }
      &-to {
        margin: 0 0.1rem;
      }
    }
  }
  .add-text {
    margin-top: 0.2rem;
    width: 3.8rem;
    & > p {
      border-radius: 0.05rem;
      border: 1px dashed #c9c9c9;
      font-size: 0.14rem;
      text-align: center;
      line-height: 0.36rem;
      cursor: pointer;
    }
  }
}
.panel-row-maxDiv {
  display: flex;
  .div {
    margin-right: 20px;
    > span {
      line-height: 26px;
      font-size: 14px;
      padding-right: 12px;
      color: #888888;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Campaign.vue